// Import dependencies
import axios from "axios";
import { setupCache } from "axios-cache-adapter";

// Create `axios-cache-adapter` instance
export const cache = setupCache({
	maxAge: 15 * 60 * 1000,
	limit: 50,
});

cache.clear = (key, useRegex) => {
	try {
		let cacheStore = cache.store.store;
		if (!key) {
			cacheStore = {};
			return true;
		}

		let hasKeyMatched = false;

		if (typeof key === "string") {
			const keyRegex = useRegex ? new RegExp(key) : null;

			for (let storeKey in cacheStore) {
				if (storeKey === key || (keyRegex !== null && keyRegex.test(storeKey))) {
					hasKeyMatched = true;
					delete cacheStore[storeKey];
					if (!useRegex) return true;
				}
			}
		}

		return hasKeyMatched;
	} catch (err) {
		console.log(err);
		return false;
	}
};

const isIE = () => {
	// Detect MSIE (from version 6 to 11)
	return navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > -1;
};

let axiosOptions = {};
if (!isIE()) {
	axiosOptions.adapter = cache.adapter;
}

// Create `axios` instance passing the newly created `cache.adapter`
export const api = axios.create(axiosOptions);

export default api;
